<p class="body mb-12">We'll use these to contact you about the repair.</p>

<section class="flex flex-col gap-12">
  @for (step of vm.stepConfig; track step.groupId) {
    @if (vm.isEditing) {
      @if (step.name === 'phone_secondary') {
        @if (vm.showSecondaryPhoneField) {
          <ng-container *ngTemplateOutlet="inputField; context: { $implicit: step }"></ng-container>
        } @else {
          <app-button
            dataLabel="additional-phone-button"
            class="min-w-160 mt-12"
            [buttonOptions]="{
              fill: false,
              variant: 'link',
              isLink: false,
            }"
            (click)="addSecondaryPhone()"
          >
            <i class="fa-light fa-md fa-circle-plus colored mr-8" aria-hidden="true"></i>
            <span class="link-text large"> Add another phone (optional) </span>
          </app-button>
        }
      } @else {
        <ng-container *ngTemplateOutlet="inputField; context: { $implicit: step }"></ng-container>
      }

      @if (!vm.valid && vm.errors[step.name]?.length) {
        <section class="error mt-2">
          <i class="fa-light fa-circle-exclamation"></i>
          <p class="body">{{ vm.errors[step.name][0] }}</p>
        </section>
      }
    } @else if (vm.formValue[step.name]) {
      <section class="gap-4">
        <p class="label">{{ step.title }}</p>
        <p class="body">{{ step.value }}</p>
      </section>
    }
  }

  <ng-template #inputField let-step>
    <app-text-input
      [label]="step.title"
      [placeHolder]="step.placeholder"
      [ngModel]="vm.formValue[step.name]"
      (ngModelChange)="validateForm()"
      [name]="step.name"
      class="body blocked"
    />
  </ng-template>

  @if (!vm.isEditing) {
    <app-button
      dataLabel="change-details-button"
      class="min-w-160"
      [buttonOptions]="{
        fill: false,
        variant: 'link',
        isLink: false,
      }"
      (click)="editDetails()"
    >
      <i class="fa-light fa-md fa-edit colored mr-8"></i>
      <span class="link-text large"> Change my details </span>
    </app-button>
  }
</section>

@if (vm.address?.lines?.length) {
  <section>
    <p class="label mb-12">Repair address</p>

    @for (line of vm.address?.lines; track line) {
      <p class="body">{{ line }}</p>
    }

    <p class="body">{{ vm.address?.postalcode }}</p>

    <section class="email-link flex items-center gap-8 mt-8">
      <a [href]="navUrl" class="link-text large"> Edit address </a>
      <i class="fa-light fa-md fa-arrow-right colored"></i>
    </section>
  </section>
}

<app-info-box variant="last-chance" />

<!-- Needed to store values when form is not in edit mode -->
<section class="hidden">
  <input type="text" name="email_address" [ngModel]="vm.formValue['email_address']" />
  <input type="text" name="phone_primary" [ngModel]="vm.formValue['phone_primary']" />
  <input type="text" name="phone_secondary" [ngModel]="vm.formValue['phone_secondary']" />
</section>
